var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoStandardProfile = function SvgIcoStandardProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "#EEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M20 24a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 16a19.94 19.94 0 0 0 14.282-6A19.94 19.94 0 0 0 20 28a19.94 19.94 0 0 0-14.283 6A19.94 19.94 0 0 0 20 40",
    clipRule: "evenodd"
  })));
};
export default SvgIcoStandardProfile;